module.exports = __webpack_public_path__ + "static/images/google-g-logo.3cec7ff9f6f03f29d70187064e240d54.svg";